import { render, staticRenderFns } from "./ArrivalRecordForm.vue?vue&type=template&id=106d9422"
import script from "./ArrivalRecordForm.vue?vue&type=script&lang=js"
export * from "./ArrivalRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports